import React from "react";
import {
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Fab,
  CircularProgress
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AddIcon from "@mui/icons-material/Add";
import YesNoQuestion from "./YesNoQuestion";
import RangeQuestion from "./RangeQuestion";
import ChoiceQuestion from "./ChoiceQuestion";
import TextQuestion from "./TextQuestion";
import NewQuestionDialog from "./NewQuestionDialog";

const Questions = ({ questions, refresh }) => {
  const [dialogOpen, setDialogOpen] = React.useState(false);

  const renderQuestions = (category) => {
    const qList = questions.filter((q) => q.category === category);
    return qList[0].questions.map((question) => {
      if (question.questionType === "yesno") {
        return <YesNoQuestion key={question._id} questionData={question} />;
      } else if (question.questionType === "choice") {
        return <ChoiceQuestion key={question._id} questionData={question} />;
      } else if (question.questionType === "range") {
        return <RangeQuestion key={question._id} questionData={question} />;
      } else if (question.questionType === "text") {
        return <TextQuestion key={question._id} questionData={question} />;
      }
    });
  };

  if (!questions) {
    return (
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          padding: 50,
        }}
      >
        <CircularProgress size={75} />
      </div>
    );
  }

  return (
    <Grid container>
      {questions ? (
        <Grid item xs={12}>
          {questions.map((data) => {
            return (
              <Accordion key={data?.category}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography variant="button">{data?.category}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid container direction="column" spacing={3}>
                    {renderQuestions(data?.category)}
                  </Grid>
                </AccordionDetails>
              </Accordion>
            );
          })}
        </Grid>
      ) : (
        <></>
      )}
      <Fab
        color="primary"
        aria-label="add"
        style={{ position: "fixed", bottom: "5%", right: "5%" }}
        onClick={() => setDialogOpen(true)}
      >
        <AddIcon />
      </Fab>
      <NewQuestionDialog
        open={dialogOpen}
        close={() => {
          refresh();
          setDialogOpen(false);
        }}
      />
    </Grid>
  );
};

export default Questions;
